<template>
  <div class="gz-swiper popout" v-loading.fullscreen.lock='loading' element-loading-text="数据加载中..."
    element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)">
    <!-- 列表 -->

    <div class="table_cm">
      <div class="bgc-header">
        <div class="search-item">
          <!-- <el-button type="primary" size="small" @click="exportCode">批量导出二维码</el-button> -->
          <el-button type="primary" size="small" @click="addContainer">+ 新建货架</el-button>
        </div>
        <div class="el-icon">
          <i class="el-icon-warning-outline"></i>已建立 <span style="color: #0090f0;">{{ total }}</span> 个货架
        </div>
      </div>

      <el-table @selection-change="handleSelectionChange" :data="PowerInfo" style="width: 100%" height="740" element-loading-background="rgba(0, 0, 0, 0.1)">
        <el-table-column
      type="selection"
      width="55">
    </el-table-column>
        <el-table-column prop="shelfname" label="货架名称" align="center">
        </el-table-column>
        <el-table-column prop="remark" label="货架描述" align="center">
        </el-table-column>
        <el-table-column prop="insNum" label="已绑定仪器数" align="center">
        </el-table-column>
        <el-table-column prop="number" label="排序" align="center">
        </el-table-column>
        <el-table-column prop="createtime" label="创建时间" align="center">

        </el-table-column>

        <el-table-column label="操作" align="center" fixed="right" width="180">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click.native.prevent="switching(scope.row)">库位明细</el-button>
            <el-button type="text" size="small"
              @click.native.prevent="editContainer(scope.row, scope.$index)">编辑</el-button>
            <el-button type="text" size="small" style="color: red;"
              @click.native.prevent="delContainer(scope.row.id)"  :disabled="scope.row.insNum > 0">删除</el-button>
          </template>
        </el-table-column>

      </el-table>
    </div>
    <div class="resource-block" v-if="PowerInfo.length > 0">
      <el-pagination background prev-text="前一页" next-text="后一页" layout="prev, pager, next" :total="total"
        :current-page.sync="currentPage" :page-size="pageSize" @current-change="pageChange"></el-pagination>
    </div>
    <!-- 电源控制器修改 -->
    <div class="addModel myDialog">
      <el-dialog :title="!pInfo ? '新增货架' : '编辑货架'" :visible.sync="editVisible" v-if="editVisible" width="500px">
        <addContainer @cancel="editVisible = false" :maxNum="maxNum" @submit="submitPower" ref="editmodel"
          :pInfo='pInfo'>
        </addContainer>
      </el-dialog>
    </div>

  </div>
</template>

<script>
import {
  deletePower,
  getMaxNumber,
  shelfPage,
  shelfDelete,
  addShelf,
  exportQrcode
} from "@/api/warehouse";
import addContainer from "./addContainer.vue";
export default {
  name: "powerSwiper",
  components: {
    addContainer
  },
  props: {
    depotInfo: {
      type: Object,
      default: {},
    },
  },
  inject: ["reload"],
  data() {
    return {
      multipleSelection: [],
      pInfo: null,
      maxNum: 0,
      pbindVisible: false,
      cloumns: [],
      editVisible: false, //电源控制器修改弹窗
      depotId: "", //仓库id
      PowerInfo: [], //电源控制器列表
      currentPage: 1, //当前页数
      pageSize: 10, //每页显示数量
      total: 0, //总数
      loading: false,
    }
  },
  watch: {
    depotInfo: {
      handler(val) {
        this.depotId = val.id;
        this.getPowerList();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    handleSelectionChange(val) {
        this.multipleSelection = val;
      },
    exportCode(){
      if(this.multipleSelection.length==0){
        this.$message({
          message: '请勾选需要导出的货架',
          type: 'warning'
        });
        return
      }
      let ids = this.multipleSelection.map(it => it.id)
      exportQrcode(ids).then((res) => {
          this.mixin.blobDownload(res.data,'货架信息.xlsx');
        }).catch((error) => {
          this.mixin.blobErrorTip(error);
        });
      },
    switching(data) {
      this.$emit('change', data, 'childContainerSwiper')
    },
    submitPower(data) {
      addShelf({ ...data, depotid: this.depotId, })
        .then((res) => {
          if (res.code == 200) {
            this.editVisible = false;
            this.$message.success(this.pInfo ? '修改成功' : "新增成功!");
            this.getPowerList();
          } else {

            this.$message.error(res.msg || "网络请求错误");
          }
        })
        .catch((err) => {

          this.$message.error(err.msg || err.message || "网络请求错误");
        });
    },
    // 点击页码操作
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPowerList();
    },

    //获取电源控制器信息
    getPowerList() {
      let params = {
        depotid: this.depotId,
        current: this.currentPage,
        size: this.pageSize
      };
      this.loading = true;
      shelfPage(params)
        .then((res) => {
          if (res.code == 200) {
            this.PowerInfo = res.data.records;
            this.total = res.data.total;
          } else {
            this.PowerInfo = [];
            this.$message.error(res.msg || "网络请求错误");
          }
          this.loading = false;
        })
        .catch((err) => {
          this.PowerInfo = [];
          this.loading = false;
          this.$message.error(err.msg || err.message || "网络请求错误");
        });
    },


    //分页功能
    pageChange(page) {
      this.currentPage = page;
      this.getPowerList();
    },
    async addContainer() {
      this.pInfo = null
      this.maxNum = await getMaxNumber({depotId: this.depotId});
      this.editVisible = true;
    },
    // 电源控制器编辑
    editContainer(row, index) {
      this.pInfo = row
      this.editVisible = true;
    },
    // 电源控制器删除
    delContainer(pid) {
      this.$confirm("确定删除该货架吗？", "删除提示", {
        confirmButtonText: "确 定",
        cancelButtonText: "取 消",
        type: "warning",
      })
        .then(() => {
          shelfDelete(pid).then((res) => {
            if (res.code == "200") {
              this.$message.success("删除成功!");
              this.getPowerList();
            } else {
              this.$message.error("删除失败！" + res.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },



    cancel() {

    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/commonStyle.less";

.resource-block {
  text-align: center;
}

.bindState-ybd {
  color: #3177EC
}

.bindState-ybd::before {
  content: '';
  width: 8px;
  display: inline-block;
  height: 8px;
  background-color: #3177EC;
  border-radius: 50%;
  margin-right: 3px;
}

.bindState-wbd::before {
  content: '';
  width: 8px;
  display: inline-block;
  height: 8px;
  background-color: #ccc;
  border-radius: 50%;
  margin-right: 3px;
}

.search-item {
  margin-top: 10px;
  text-align: right;
  margin-right: 10px;

  .myinput {
    width: 300px;
  }

  // .element-list {
  //   border: 2px solid #0090f0;
  //   border-radius: 6px;
  //   height: 30px;
  //   width: 150px;
  //   line-height: 30px;
  //   text-align: center;
  //   /deep/ .el-input__inner {
  //     background-color: rgba(0, 0, 0, 0);
  //     color: #fff;
  //     border: 0px;
  //     border-radius: 0px;
  //     text-align: center;
  //   }
  //   /deep/ input::-webkit-input-placeholder {
  //     color: #74c8fe;
  //   }
  //   /deep/ input::-moz-input-placeholder {
  //     color: #74c8fe;
  //   }
  //   /deep/ input::-ms-input-placeholder {
  //     color: #74c8fe;
  //   }
  // }
}

//温湿度样式
.kzq {
  .card-list {
    width: 100%;
    height: 730px;

    /deep/ [class^="el-icon-"] {
      font-size: 20px;
    }

    /deep/.el-switch__core:after {
      background-color: #718cd9;
      width: 13px;
      height: 13px;
    }

    /deep/.el-switch__core {
      border-color: #67baf0 !important;
      width: 47px;
      height: 17px;
    }

    /deep/.el-switch.is-checked .el-switch__core::after {
      left: 100%;
      margin-left: -14px;
    }

    .yq-card-item {
      width: 32.3333%;
      float: left;
      box-sizing: border-box;
      margin-bottom: 10px;
      margin-left: 1%;
      height: 350px;
      border: 2px solid#0090F0;
      box-shadow: 0 0 33px#0090F0 inset;
      border-radius: 4px;

      .equip-item-top {
        width: 100%;
        height: 40%;
        padding: 10px;
        box-sizing: border-box;
        background: linear-gradient(180deg,
            rgba(0, 210, 255, 0.52),
            rgba(0, 57, 142, 0.52));
        display: flex;

        .top-left {
          width: 35%;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .ico-power {
            font-size: 80px;
            text-align: center;
            color: #75c8fe;
            margin-bottom: 10px;
          }
        }

        .top-right {
          width: 65%;
          height: 100%;

          .el-button.is-circle {
            padding: 0;
          }

          div {
            height: 40px;
            line-height: 40px;
          }

          .top-name {
            display: flex;
            justify-content: space-between;

            .power-name {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .power-edit {
              width: 30px;
              text-align: end;
            }
          }

          .top-pw {
            display: flex;
            justify-content: space-between;
            padding-right: 20px;
          }
        }
      }

      .equip-item-bottom {
        width: 100%;
        height: 60%;
        background: rgba(8, 19, 41, 0.5);
        box-shadow: 0 0 15px #0071f1 inset;
        padding: 10px;
        box-sizing: border-box;
        display: flex;

        .bottom-left {
          box-sizing: border-box;
          width: 40%;
          padding: 15px;

          img {
            width: 160px;
            height: 160px;
          }
        }

        .bottom-right {
          width: 60%;
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          height: 40px;
          line-height: 40px;

          .el-button.is-circle {
            padding: 0;
          }

          span {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
  }
}

.not_info {
  margin: 0 auto;
  margin-top: 20px;
  width: 1570px;
  color: #74c8fe;
  font-size: 24px;
  text-align: center;

  .info_text {
    margin-top: 320px;
  }
}

ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}

.bgc-header {
  background-color: #fff;
  display: flex;
  flex-direction: column;

  .el-icon {
    height: 35px;
    line-height: 35px;
    background-color: #74c8fe38;
    color: #666;
    border: 1px solid #74c8fe38;
    width: 90%;
    border-radius: 4px;
    margin-left: 2%;
    margin-top: 10px;
    padding-left: 10px;

  }
}
</style>


// WEBPACK FOOTER //
// src/views/warehouse/components/containerSwiper.vue